<template>
    <div>
        <v-toolbar dark color="info" fixed>
            <v-toolbar-title class="white--text">
                <a href="/#/analytics"><img src="../assets/logo-new.png"></a>
            </v-toolbar-title>
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on:click="analytics()" v-on="on">
                      <v-icon>insert_chart_outlined</v-icon>
                    </v-btn>
                </template>
                <span>Analytics</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on:click="gateins()" v-on="on">
                      <v-icon>input</v-icon>
                    </v-btn>
                </template>
                <span>Gate In</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on:click="sealbreak()" v-on="on">
                      <v-icon>gavel</v-icon>
                    </v-btn>
                </template>
                <span>Seal Breaking</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on:click="fclgateout()" v-on="on">
                      <v-icon>list_alt</v-icon>
                    </v-btn>
                </template>
                <span>FCL Gate Out</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on:click="destuffcargo()" v-on="on">
                      <v-icon>apps</v-icon>
                    </v-btn>
                </template>
                <span>De-Stuff Cargo Out</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on:click="ecgateout()" v-on="on">
                      <v-icon>video_label</v-icon>
                    </v-btn>
                </template>
                <span>MTY Out</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on:click="conthistorylist()" v-on="on">
                      <v-icon>flip_to_front</v-icon>
                    </v-btn>
                </template>
                <span>Container History</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on:click="logout()" v-on="on">
                      <v-icon>power_settings_new</v-icon>
                    </v-btn>
                </template>
                <span>Log Out</span>
            </v-tooltip>
        </v-toolbar>
        <br />
        <br />
        <v-navigation-drawer v-model="drawer" absolute temporary>
            <div class="vuebar-element">
            <v-list class="pa-1"  color="primary">
                <v-list-tile avatar>
                <v-list-tile-avatar>
                    <img src="../assets/logo-banner.png">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>{{ username }}</v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <v-list class="pt-0" dense>
                <v-divider></v-divider>
                <v-list-tile v-for="item in main_menu" :key="item.title" v-bind:href="item.links">
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-group prepend-icon="storage" value="true">
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-title>Reports</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <v-list-tile v-for="(report, i) in reports" :key="i" v-bind:href="report.routers">
                        <v-list-tile-title>{{ report.title }}</v-list-tile-title>
                    </v-list-tile>
                </v-list-group>
                <v-list-group prepend-icon="launch" value="true">
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-title>Master</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <v-list-tile v-for="(master, i) in masters" :key="i" v-bind:href="master.routers">
                        <v-list-tile-title>{{ master.title }}</v-list-tile-title>
                    </v-list-tile>
                </v-list-group>
            </v-list>
    </div>
    </v-navigation-drawer>
</div>

</template>

<script>
export default {
    name: 'sidemainmenu',
    data () {
      return {
            drawer: null,
            username: '',
            main_menu: [
              { title: 'Analytics', icon: 'dashboard', links: '/#/analytics' },
              { title: 'Import Arrival', icon: 'question_answer', links: '/#/arrivals' },
              { title: 'IGM', icon: 'open_with', links: '/#/igms' },
              { title: 'Gate In', icon: 'forward', links: '/#/gateins' },
              { title: 'Seal Breaking', icon: 'gavel', links: '/#/sealbreaking' },
              { title: 'FCL', icon: 'local_shipping', links: '/#/fclgateout' },
              { title: 'De Stuff', icon: 'store', links: '/#/destuffcargo' },
              { title: 'EC Gate Out', icon: 'send', links: '/#/ecgateout' },
              { title: 'Gate In Pass', icon: 'trending_flat', links: '/#/gateinpass' }
            ],
            masters: [
                { title: 'Vessel', routers: '/#/vessels'},
                { title: 'Size Type', routers: '/#/sizetypes'},
                { title: 'Unit', routers: '/#/units'},
                { title: 'State', routers: '/#/states'},
                { title: 'Terminal', routers: '/#/terminals'},
                { title: 'Customer', routers: '/#/customers'},
                { title: 'Importer', routers: '/#/importers'},
                { title: 'Transport', routers: '/#/transports'},
                { title: 'Line', routers: '/#/lines'}
            ],
            reports: [
                { title: 'Stock Report', routers: '/#/reports/stock'},
                { title: 'Delivery Report', routers: '/#/reports/delivery'}
            ]
        }
    },
    methods: {
        analytics() {
            this.$router.push('/analytics')
        },
        vessel() {
            this.$router.push('/vessel')
        },
        gateins() {
            this.$router.push('/gateins')
        },
        sealbreak() {
            this.$router.push('/sealbreaking')
        },
        fclgateout() {
            this.$router.push('/fclgateout')
        },
        destuffcargo() {
            this.$router.push('/destuffcargo')
        },
        ginpass() {
            this.$router.push('/ginpass')
        },
        ecgateout() {
            this.$router.push('/ecgateout')
        },
        conthistorylist() {
            this.$router.push('/conthistorylist')
        },
        logout: function() {
            localStorage.clear();
            this.$router.push('/')
        }
    },
      mounted() {
        if (localStorage.username) {
          this.username = localStorage.username;
        }
      }
};
</script>
